(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabFleets', TabFleets)
        .factory('UserForSelect', UserForSelect);

    TabFleets.$inject = ['$resource'];

    function TabFleets($resource) {
        var resourceUrl = 'api/tab-fleets/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'domains': {
                url:'api/tab-fleets/domains/:id',
                method: 'GET',
                isArray: true
            },
            'all': {
                url:'api/tab-fleets/all-domains',
                method: 'GET',
                isArray: true
            },
            'domainsEager': {
                url:'api/tab-fleets/domainsEager/:id',
                method: 'GET',
                isArray: true
            },
            'users': {
                url:'api/tab-fleets/users',
                method: 'GET',
                isArray: true
            },
            'filterType': {
                url:'api/tab-fleets/filterClass/:className',
                method: 'GET',
                isArray: true
            },
            'warnings': {
                url:'api/tab-fleets/warnings',
                method: 'GET'
            },
            'filterClass': {
                url: 'api/tab-fleets/filterByClassId',
                method: 'GET',
                isArray: true
            }
        });
    }

    UserForSelect.$inject = ['$resource'];

    function UserForSelect($resource) {
        var resourceUrl = 'api/users-select/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
